import { render, staticRenderFns } from "./GalleryType5.vue?vue&type=template&id=41ae3fb1"
import script from "./GalleryType5.vue?vue&type=script&lang=js"
export * from "./GalleryType5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ae3fb1')) {
      api.createRecord('41ae3fb1', component.options)
    } else {
      api.reload('41ae3fb1', component.options)
    }
    module.hot.accept("./GalleryType5.vue?vue&type=template&id=41ae3fb1", function () {
      api.rerender('41ae3fb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/product/gallery/GalleryType5.vue"
export default component.exports